import { InjectionToken } from '@angular/core';

export const DISABLE_IOS_DOWNLOAD = new InjectionToken<boolean>('disableiOSDownload');
export const DISABLE_ANDROID_DOWNLOAD = new InjectionToken<boolean>('disableAndroidDownload');
